import { type Setter, Show } from 'solid-js'

import { Button } from '@/components/ui/button'
import { FilterSection } from '@components/FilterControls'
import { RotateCcw, Sparkle } from 'lucide-solid'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Flex, Grid } from 'styled-system/jsx'
import { useFilters } from '../state/filter'
import { AssetType } from './AssetType'
import Duration from './Duration'
import Exchange from './Exchange'
import { NewSort } from './NewSort'
import { PatternSpecification } from './PatternSpecification'
import { Position } from './Position'
import SearchIn from './SearchIn'
import { Stage } from './Stage'
import SymbolSearch from './Symbol'

export default function (props: { setIsOpen: Setter<boolean> }) {
  const { resetFilters, fetchFilters, setAuthor } = useService(useFilters)()

  return (
    <Flex
      h="100%"
      w="100%"
      flexDirection="column"
      justifyContent="space-between"
      gap={6}
    >
      <Grid gap={6}>
        <FilterSection title='Search'>
          <SearchIn />
        </FilterSection>
        <FilterSection title='Instrument'>
          <SymbolSearch />
          <Exchange />
          <AssetType />
        </FilterSection>
        <FilterSection title='Setup'>
          <Position />
          <Stage />
          <PatternSpecification />
          <Duration />
        </FilterSection>
        <FilterSection title='Order'>
          <NewSort />
        </FilterSection>
        <Show when={fetchFilters().author}>
          <Button size='sm' variant='outline' onClick={() => setAuthor(null)}>
            Show setups from everyone
          </Button>
        </Show>
        {/* <Source /> */}
        {/* <Order /> */}
      </Grid>
      <Flex
        justifyContent="space-between"
        position='sticky'
        bottom='0'
        py='3'
        bg='gray.surface.bg'
        class={css({ borderTopWidth: '1px', borderColor: 'border' })}
      >
        <Button
          onClick={resetFilters}
          variant="outline"
          colorPalette="tscGreen"
        >
          Reset Filters
          <RotateCcw />
        </Button>
        <Button
          onClick={() => props.setIsOpen(false)}
          variant="solid"
          colorPalette="jade"
        >
          Show results
          <Sparkle />
        </Button>
      </Flex>
    </Flex>
  )
}
